import { render } from "./ValidationObserver.vue?vue&type=template&id=730b28ef"
import script from "./ValidationObserver.vue?vue&type=script&lang=js"
export * from "./ValidationObserver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__